<div class="booking">

    <div class="index-head" fxLayout="row" fxLayoutAlign="space-between center">
        <div class="index-head">
            <span>Change Owner</span>
        </div>

        <button [attr.guide]="'transfer-lead-btn-1' + '__' + sanitizeUrl(url)" mat-icon-button>
            <mat-icon (click)="close()">
                close
            </mat-icon>
        </button>
    </div>

    <div class="padding-10">
        <span>Select the New Owner to Transfer the Lead</span>
    </div>

    <div class="padding-10" [formGroup]="firstFormGroup">
        <div fxLayout="row" *ngIf="!enableReason" fxLayout.lt-md="column" fxLayoutGap="10px">

            <div *ngIf="randomAssign==0;else other_content" fxFlex>
                <mat-form-field fxFlex appearance="outline">
                    <mat-label>Transfer Lead </mat-label>
                    <mat-select required formControlName="userToId" [disableOptionCentering]="true" #singleSelect
                        autocomplete="off">
                        <mat-option>
                            <ngx-mat-select-search name="Owner Search" ngDefaultControl
                                [formControl]="typeYFilterControl" placeholderLabel="Owner Search"
                                [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
                            </ngx-mat-select-search>
                        </mat-option>
                        <mat-option (onSelectionChange)="checkTransferReasonEnable($event)"
                            *ngFor="let opt of filtereduserTypeList; let i=index;" [value]="opt.entityId">
                            {{opt.email}}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="firstFormGroup.controls.userToId.errors?.required">
                        Please fill out this field.

                    </mat-error>

                </mat-form-field>
            </div>

            <ng-template #other_content>


                <mat-form-field fxFlex appearance="outline">
                    <mat-label>Transfer Lead</mat-label>
                    <mat-select formControlName="ownerMultiCtrl" [disableOptionCentering]="true" [multiple]="true"
                        required #multiSelect>
                        <mat-option>
                            <ngx-mat-select-search name="Owner Search" ngDefaultControl
                                [formControl]="typeYFilterControl" placeholderLabel="Owner Search"
                                [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
                            </ngx-mat-select-search>
                        </mat-option>
                        <mat-option (onSelectionChange)="selectOwner($event,opt)"
                            *ngFor="let opt of filtereduserTypeList; let i=index;" [value]="opt.entityId">
                            {{opt.email}}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="firstFormGroup.controls.ownerMultiCtrl.errors?.required">
                        Please fill out this field.</mat-error>
                </mat-form-field>
            </ng-template>



        </div>


        <div *ngIf="enableReason" fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="24px">


            <mat-form-field appearance="outline" fxFlex>
                <mat-label>Reason for Transfer</mat-label>
                <textarea [attr.guide]="'transfer-lead-sel-transfermessage' + '__' + sanitizeUrl(url)" trim="blur" formControlName="transferMessage" matTextareaAutosize matAutosizeMinRows=1
                    matAutosizeMaxRows=5 matInput matInput required>
                </textarea>

                <mat-error *ngIf="firstFormGroup.controls.transferMessage.errors?.required">
                    Please fill out this field.

                </mat-error>

            </mat-form-field>

        </div>

    </div>

    <div class="padding-10" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="20px">
        <button [attr.guide]="'transfer-lead-btn-2' + '__' + sanitizeUrl(url)" type="button" mat-raised-button (click)="close()">Cancel
        </button>

        <button [attr.guide]="'transfer-lead-btn-3' + '__' + sanitizeUrl(url)" [disabled]="text !='Save'" (click)="submit()" mat-raised-button>
            {{text}}
            <mat-icon *ngIf="text !='Save' ">
                <mat-spinner color="primary" diameter="20">
                </mat-spinner>
            </mat-icon>
        </button>
    </div>
</div>